import { render, staticRenderFns } from "./KeywordsManagement.vue?vue&type=template&id=8f817516&scoped=true"
import script from "./KeywordsManagement.vue?vue&type=script&lang=js"
export * from "./KeywordsManagement.vue?vue&type=script&lang=js"
import style0 from "./KeywordsManagement.vue?vue&type=style&index=0&id=8f817516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f817516",
  null
  
)

export default component.exports